import { TextSelection } from '@atlaskit/editor-prosemirror/state';

import type {
	InsertNodeBeforeCommand,
	StreamingCommandFactory,
} from '../aiStreamingOrchestratorPluginType';

import { findNodeByLocalId } from './utils/find-node-by-local-id';

export const createInsertNodeBeforeCommand: StreamingCommandFactory<InsertNodeBeforeCommand> =
	(api) => (command) => {
		api.core.actions.execute(({ tr }) => {
			findNodeByLocalId(api, tr, command.localId, ({ pos }) => {
				const selection = new TextSelection(tr.doc.resolve(pos));
				tr.setSelection(selection).scrollIntoView();
			});
			return tr;
		});
		return true;
	};
